import { createContext } from 'react'
import { Locale } from 'types/Locale'

export const LocaleContext = createContext<Locale>('de')
